import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import UnauthorizedModal from "./UnauthorizedModal";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [loginError, setLoginError] = useState(false)
  const [popupModal, setPopup] = useState(false)

  const navigate = useNavigate();
  const login = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", user);
    navigate("/home");
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"))?.SwitchUser;
  };

  const getCurrentRealUser = () => {
    return JSON.parse(localStorage.getItem("user"));
  };

  const getCurrentRole = () => {
    return JSON.parse(localStorage.getItem("user"))?.SwitchUser?.Role;
  };

  const getCurrentRealUserRole = () => {
    return JSON.parse(localStorage.getItem("user"))?.Role ?? "";
  };

  return (
    <AuthContext.Provider value={{
      login,
      logout,
      getCurrentUser,
      getCurrentRealUser,
      getCurrentRole,
      getCurrentRealUserRole,
      loginError,
      setLoginError,
      popupModal,
      setPopup
    }}>
      {children}
      <UnauthorizedModal show={popupModal} closePopup={setPopup} logout={logout} />
    </AuthContext.Provider>
  );
};
